import { CloseIcon, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { useDeviceDetect } from '@fable/hooks'
import Searchbar from 'app/global/components/Searchbar'
import SearchResults from 'app/global/components/SearchResults'
import { useBranchView, useLoadSearch } from 'hooks'
import { HomeClubsSearchButton } from './HomeClubsSearchButton'

export const HomeClubsSearch = () => {
  const { showSearch, setShowSearch, setInput, setSearchbarFocus } =
    useLoadSearch({
      filter: 'club',
    })
  const { isMobile } = useDeviceDetect()
  const bannerInView = useBranchView()
  const { nativeOverrides, mediaQueries } = useTheme()

  return (
    <>
      <HomeClubsSearchButton
        onClick={() => {
          setShowSearch(true)
          setSearchbarFocus(true)
        }}
      />
      <div
        className={cx(
          css`
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: calc(100% - 37px);
            z-index: 3;
            background: white;
            opacity: ${showSearch ? 1 : 0};
            pointer-events: ${showSearch ? 'auto' : 'none'};
          `,
          isMobile &&
            bannerInView &&
            css`
              top: 64px;
            `
        )}
      >
        <div
          className={css`
            width: 100%;
            max-width: 876px;
            margin: 28px 0 32px 0;
            @media only screen and (min-width: 900px) {
              margin: 28px auto 32px auto;
            }
          `}
        >
          <button
            onClick={() => {
              setInput('')
              setShowSearch(false)
            }}
            className={cx(
              nativeOverrides.buttonClear,
              css`
                margin-bottom: 22px;
                margin-left: 28px;
                @media only screen and (min-width: 900px) {
                  margin-left: 0;
                }
              `
            )}
          >
            <CloseIcon />
          </button>
          <Text
            className={css`
              text-align: center;
              width: 100%;
              margin: 0 auto;
            `}
            tag="p"
            type="header"
            sizing="S"
          >
            Search thousands
            <span
              className={css`
                display: block;
                ${mediaQueries.mobileL} {
                  margin-left: 4px;
                  display: inline;
                }
              `}
            >
              of book clubs to join
            </span>
          </Text>
        </div>
        <Searchbar
          onClick={() => {
            setShowSearch(true)
            // hack to combat Safari pushing the UI up
            setTimeout(() => {
              window.scrollTo({ top: 0 })
            }, 200)
          }}
          className={css`
            padding: 0 28px;
            max-width: 876px;
            margin-bottom: 32px;
            @media only screen and (min-width: 900px) {
              padding: 0;
              margin: 0 auto 32px auto;
            }
          `}
          defaultFilter="club"
        />
        <SearchResults />
      </div>
    </>
  )
}
